import mustache from "mustache";
import { serviceProvider } from "../../../comun/provider/ServiceProvider";
import { fx_createFincaClimaHorarioGrpcService } from "../../../modulos/clima/services/FincaClimaHorarioGrpcService";
import { FincaClimaDataHorarioResponse } from "../../../modulos/clima/response/FincaClimaDataHorarioResponse";
import { _2d } from "../../../utils/numberUtils";
import { ClimaSeccionBase } from "./ClimaSeccionBase";
import template from "./climaHorarioStatsTemplate.html";

mustache.parse(template);

/** Misma cadencia que `ClimaHeaderRender` en modo horario. */
const REFRESH_INTERVAL_MS = 60_000;

let STATS_ID = 0;

/** Sección "Precipitación / Vientos / Nubosidad" de la hora vigente (Current).
 *  Se refresca solo cada minuto (ver `ClimaSeccionBase`). */
export class ClimaHorarioStatsRender extends ClimaSeccionBase<FincaClimaDataHorarioResponse> {
  private readonly _statsId: number;

  constructor() {
    super(REFRESH_INTERVAL_MS);
    STATS_ID += 1;
    this._statsId = STATS_ID;
  }

  render(): string {
    return mustache.render(template, { statsId: this._statsId });
  }

  protected fetchList(): Promise<FincaClimaDataHorarioResponse[]> {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    return fx_createFincaClimaHorarioGrpcService(finca.id).getListAsync();
  }

  protected onVigente(current: FincaClimaDataHorarioResponse): void {
    this._setValue("precipitacion", `${_2d(current.precipitation)} mm`);
    this._setValue(
      "precipitacion-prob",
      `${_2d(current.precipitationProbability)} %`,
    );
    this._setValue("viento-velocidad", `${_2d(current.windspeed)} m/s`);
    this._setValue("viento-direccion", `${_2d(current.winddirection)}`);
    this._setValue("nubosidad", `${_2d(current.totalcloudcover)} %`);
  }

  private _setValue(key: string, text: string): void {
    const el = document.getElementById(`chs-${key}-${this._statsId}`);
    if (el) el.textContent = text;
  }
}
